
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getWorkUser } from '@/api/users';
import { getDepartmentList } from '@/api/company';
import { UserModule } from '@/store/modules/user';
import { checkPermissionCompanyFromOrderType, checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';
import { taskCooperate, taskJiXiu, taskRemote, taskSendRepair, taskTransfer, taskVisit } from '@/api/orderTask';
import { addAddress, getAddress } from '@/api/address';

import OrderArea from '@/views/order/components/OrderArea.vue';
import { regular } from '@/const/regular';

@Component({
  name: 'TaskProcessDialog',
  components: {
    OrderArea
  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  selectedTaskProcessVisible!: Boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  appointmenTimeMust!: boolean;

  @Prop({
    type: Object,
    default: () => {}
  })
  taskDetail!: any;

  private dealList:any=[]

  private radioWay = 0
  private searchDept: any = {
    name: ''
  }
  private formAddressSearch:any={
    name: ''
  }
  private deptLoading = false;
  private deptTableData: any = []
  private page:number=1;
  private pageCount:number=1;
  private selectedData:any = {}

  // 人员
  private formSearch: any = {
    name: '',
    dept: ''
  };
  private engList:any = [];
  private listLoading = false;
  private engPage:number=1
  private engPageCount:number=1;

  private selectedUserData:any={}
  private selectedUserDataList:any=[]

  private depttype:any='2'

  created() {
    if (this.taskDetail && this.taskDetail.order && this.taskDetail.order_task) {
      this.dealList = [
        { id: 1,
          show: checkPermissionCompanyFromOrderType(this.taskDetail.order_task.company_id, Type.TASK_SONGXIU, this.taskDetail.order.order_type) &&
                checkPermissionUseAndCompany(this.taskDetail.order_task.company_id, Type.TASK_SONGXIU),
          text: '送修' },
        { id: 2,
          show: checkPermissionCompanyFromOrderType(this.taskDetail.order_task.company_id, Type.TASK_REMOTE, this.taskDetail.order.order_type) &&
                checkPermissionUseAndCompany(this.taskDetail.order_task.company_id, Type.TASK_REMOTE),
          text: '远程' },
        { id: 3,
          show: checkPermissionCompanyFromOrderType(this.taskDetail.order_task.company_id, Type.TASK_VISIT, this.taskDetail.order.order_type) &&
                checkPermissionUseAndCompany(this.taskDetail.order_task.company_id, Type.TASK_VISIT),
          text: '上门' },
        { id: 4,
          show: checkPermissionCompanyFromOrderType(this.taskDetail.order_task.company_id, Type.TASK_SEND, this.taskDetail.order.order_type) &&
                checkPermissionUseAndCompany(this.taskDetail.order_task.company_id, Type.TASK_SEND),
          text: '寄修' },
        { id: 5,
          show: checkPermissionCompanyFromOrderType(this.taskDetail.order_task.company_id, Type.TASK_TRANSFER, this.taskDetail.order.order_type) &&
                checkPermissionUseAndCompany(this.taskDetail.order_task.company_id, Type.TASK_TRANSFER),
          text: '转派' },
        { id: 6,
          show: checkPermissionCompanyFromOrderType(this.taskDetail.order_task.company_id, Type.TASK_COORDINATION, this.taskDetail.order.order_type) &&
                checkPermissionUseAndCompany(this.taskDetail.order_task.company_id, Type.TASK_COORDINATION),
          text: '协同处理' }]
      if (this.dealList[0].show) {
        this.radioWay = 1
      } else if (this.dealList[1].show) {
        this.radioWay = 2
      } else if (this.dealList[2].show) {
        this.radioWay = 3
      } else if (this.dealList[3].show) {
        this.radioWay = 4
      } else if (this.dealList[4].show) {
        this.radioWay = 5
      } else {
        this.radioWay = 6
      }
    }
  }
  private radioWayHandle() {
    switch (this.radioWay) {
      case 1:
        break
      case 2:
        break
      case 3:
        break
      case 4:
        this.getSendRepairAddressList()
        break
      case 5:
        this.selectedData = {}
        this.getDeptList()
        break
      case 6:
        this.selectedData = {}
        this.getDeptList()
        break
    }
  }
  private search() {
    this.engPage = 1;
    this.getWorkUser()
  }

  private getWorkUser() {
    const params: any = {
      dept_id: this.selectedData.id,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      page: this.engPage,
      size: 10
    };
    if (this.taskDetail.order) {
      params.order_id = this.taskDetail.order.id;
    }
    if (this.taskDetail.order_task) {
      params.order_service_id = this.taskDetail.order_task.id;
    }
    if (this.taskDetail.order_task) {
      params.order_task_id = this.taskDetail.order_task.id;
    }
    // params.name = this.formSearch.name;
    getWorkUser(params)
      .then((res: any) => {
        if (res.data) {
          if (this.engPage === 1) {
            this.engList = res.data.list;
          } else {
            this.engList = this.engList.concat(res.data.list);
          }
          this.engPageCount = res.data.page_count;
        } else {
          if (this.engPage === 1) {
            this.engList = [];
            this.engPageCount = 1;
          }
        }
      })
      .catch((err: any) => {
        if (this.engPage === 1) {
          this.engList = [];
          this.engPageCount = 1;
        }
        let msg = err.msg;
      });
  }
  private engMore() {
    this.engPage = this.engPage + 1;
    this.getWorkUser();
  }
  private selectedEngChange(val: any) {
    if (this.selectedUserData === val) {
      this.selectedUserData = {};
    } else {
      this.selectedUserData = val;
    }
  }

  // 部门

  private getDeptList() {
    this.deptLoading = true;
    let params: any = {
      page: this.page,
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      type: this.depttype, // 部门类型 1报修部门 2服务部门 3审批部门 9所有部门 (必填)
    };
    if (this.searchDept.name) {
      params.name = this.searchDept.name;
    }
    if (this.taskDetail && this.taskDetail.order_task) {
      params.order_task_id = this.taskDetail.order_task.id;
    }
    getDepartmentList(params)
      .then((res) => {
        if (res.data) {
          this.pageCount = res.data.page_count;
          if (this.page === 1) {
            this.deptTableData = res.data.list;
            this.selectedData = this.deptTableData[0];
            // 协同处理默认选中第一个部门
            this.engPage = 1
            this.getWorkUser();
          } else {
            this.deptTableData = this.deptTableData.concat(res.data.list);
          }
        } else {
          if (this.page === 1) {
            this.deptTableData = [];
          }
        }
        this.deptLoading = false;
      })
      .catch((err) => {
        if (this.page === 1) {
          this.deptTableData = [];
        }
        this.deptLoading = false;
        let msg = err.msg;
      });
  }
  private selectedDeptChange(val: any) {
    this.engPage = 1;
    this.selectedUserData = {};
    this.getWorkUser()
  }
  private searchHandle() {
    this.page = 1;
    this.getDeptList();
  }

  private confirmHandle() {
    let pamars:any = {};
    switch (this.radioWay) {
      case 1:
        this.handleSongXiu()
        break
      case 2:
        this.handleRemote()
        break
      case 3:
        this.handleVisit()
        break
      case 4:
        if (!this.selectedAddress || !this.selectedAddress.id) {
          this.showErrorMsg('请选择收货地址');
          return;
        }
        this.handleJiXiu()
        break
      case 5:
        if (this.deptTableData && this.deptTableData.length > 0 && !this.selectedData.id && !this.selectedData.name) {
          this.showErrorMsg("请选择部门");
          return
        }
        if (!(this.selectedUserData && this.selectedUserData.user && this.selectedUserData.user.id)) {
          this.showErrorMsg("请选择人员");
          return
        }
        this.handleTransfer()
        break
      case 6:

        if (this.deptTableData && this.deptTableData.length > 0 && !this.selectedData.id && !this.selectedData.name) {
          this.showErrorMsg("请选择部门");
          return;
        }
        if (!(this.selectedUserDataList && this.selectedUserDataList.length > 0)) {
          this.showErrorMsg("请选择人员");
          return
        }
        if (this.selectedUserDataList.length > 10) {
          this.showErrorMsg('最多选择10个工程师');
          return;
        }
        this.handleCooperate()
        break
    }
  }
  private dealTask() {

  }
  // 送修
  private handleSongXiu() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = this.taskDetail.order_task.company_id;
    params.order_task_id = this.taskDetail.order_task.id;
    taskSendRepair(params).then(res => {
      this.showSuccessMsg('送修成功');
      const data = res.data;
      if (data.dispose_next && data.dispose_next.order_type !== '4') {
        this.$emit('selectedOrderProcessData', data.dispose_next)
      } else {
        this.close(true)
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 远程
  private handleRemote() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = this.taskDetail.order_task.company_id;
    params.order_task_id = this.taskDetail.order_task.id;
    taskRemote(params).then(res => {
      this.showSuccessMsg('远程处理成功');
      const data = res.data;
      if (data.dispose_next && data.dispose_next.order_type !== '4') {
        this.$emit('selectedOrderProcessData', data.dispose_next)
      } else {
        this.close(true)
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  // 上门
  private handleVisit() {
    if ((!this.taskDetail.order_service.servicer_appointment_timestamp || parseInt(this.taskDetail.order_service.servicer_appointment_timestamp) === 0) && this.appointmenTimeMust) {
      this.showErrorMsg('请选择预约时间');
      return;
    }
    let params: any = {};
    params.user_id = UserModule.getUserId;
    params.user_name = UserModule.getUserName;
    params.company_id = this.taskDetail.order_task.company_id;
    params.order_task_id = this.taskDetail.order_task.id;
    taskVisit(params).then(res => {
      this.showSuccessMsg('上门处理成功');
      const data = res.data;
      if (data.dispose_next && data.dispose_next.order_type !== '4') {
        this.$emit('selectedOrderProcessData', data.dispose_next)
      } else {
        this.close(true)
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 寄修处理
  private searchAddress() {

  }

  // 新增收货地址
  private regular = regular;
  private rules= {
    name: [
      {
        pattern: regular.userName.pattern,
        message: '请输入2-20位由字母、中文组成的姓名',
        trigger: 'blur'
      }
    ],
    address: [
      { required: true, message: '请输入2-50个字符组成的地址', trigger: 'blur' },
      {
        pattern: regular.address.pattern,
        message: '请输入2-50个字符组成的地址',
        trigger: 'blur'
      }
    ],
    mobile: [
      {
        pattern: regular.mobile.pattern,
        message: '请输入正确格式的手机号码',
        trigger: 'blur'
      }
    ],
    phone_num: [
      {
        pattern: regular.phone.pattern,
        message: '请输入3-18位电话号码',
        trigger: 'blur'
      }
    ]
  }
  private dialogAddAddressVisible = false
  private formAddAddress: any = {
    name: '',
    address: '',
    mobile: '',
    telephone: '',
    area: '',
    province: '',
    city: '',
    district: ''
  }
  private addAddressClick() {
    this.dialogAddAddressVisible = true
  }
  private clickToAddAddress() { // 先判断此处编辑是否符合规则
    (this.$refs.ruleForm as any).validate((valid: any) => {
      if (valid) {
        this.addAddressRequest();
      } else {
        return false;
      }
    });
  }
  private addAddressRequest() {
    let params: any = {
      user_id: UserModule.getUserId,
      address: this.formAddAddress.address,
      name: this.formAddAddress.name,
      mobile: this.formAddAddress.mobile,
      phone_num: this.formAddAddress.telephone,
      province_name: this.formAddAddress.province,
      city_name: this.formAddAddress.city,
      district_name: this.formAddAddress.district,
      adcode: this.formAddAddress.adcode
    };
    addAddress(params).then((res:any) => {
      this.showSuccessMsg(res.msg);
      this.dialogAddAddressVisible = false;
      this.getSendRepairAddressList();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 省市区 选择
  private areaVisible = false;
  private selectAreaHandle() {
    this.areaVisible = true;
  }
  private closeAreaHandle() {
    this.areaVisible = false;
  }
  private saveAreaHandle(val: any) {
    this.formAddAddress.province = val.province_name;
    this.formAddAddress.city = val.city_name;
    this.formAddAddress.district = val.district_name;
    this.formAddAddress.adcode = val.adcode;
    this.formAddAddress.area = val.province_name !== val.city_name
      ? val.province_name + '  ' + val.city_name + '  ' + val.district_name
      : val.province_name + '  ' + val.district_name;
    this.areaVisible = false;
  }

  private addressList:any=[]
  // 获取寄修地址
  private getSendRepairAddressList() {
    let params: any = {};
    params.user_id = UserModule.getUserId;
    getAddress(params).then(res => {
      const data = res.data;
      if (data) {
        this.addressList = data.list;
      } else {
        this.addressList = [];
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private selectedAddress:any={}

  private handleJiXiu() {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.taskDetail.order_task.company_id,
      order_task_id: this.taskDetail.order_task.id,
      send_name: this.selectedAddress.name,
      send_mobile: this.selectedAddress.mobile,
      send_phone: this.selectedAddress.phone_num,
      send_address: this.selectedAddress.address,
      send_province: this.selectedAddress.province,
      send_province_name: this.selectedAddress.province_name,
      send_city: this.selectedAddress.city,
      send_city_name: this.selectedAddress.city_name,
      send_district: this.selectedAddress.district,
      send_district_name: this.selectedAddress.district_name,
      send_latitude: this.selectedAddress.latitude,
      send_longitude: this.selectedAddress.longitude,
      send_adcode: this.selectedAddress.zip_code
      // send_adcode: this.formAddress.adcode
    };
    taskJiXiu(params).then(res => {
      this.showSuccessMsg('寄修处理成功');
      const data = res.data;
      if (data.dispose_next && data.dispose_next.order_type !== '4') {
        this.$emit('selectedOrderProcessData', data.dispose_next)
      } else {
        this.close(true)
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 转派  发送请求
  private handleTransfer() {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.taskDetail.order_task.company_id,
      order_task_id: this.taskDetail.order_task.id,
      work_dept_name: this.selectedData.dept_name,
      work_dept_id: this.selectedData.dept_id,
      work_user_name: this.selectedUserData.user.name,
      work_user_id: this.selectedUserData.user.id
    };
    taskTransfer(params).then(res => {
      this.showSuccessMsg('转派处理成功');
      const data = res.data;
      if (data.dispose_next && data.dispose_next.order_type !== '4') {
        this.$emit('selectedOrderProcessData', data.dispose_next)
      } else {
        this.close(true)
      }
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  // 协同 发送请求
  private handleCooperate() {
    var engineers: any = [];
    for (const item of this.selectedUserDataList) {
      let engineer = {
        dept_name: item.dept_name,
        dept_id: item.dept_id,
        name: item.user.name,
        user_id: item.user.id
      };
      engineers.push(engineer);
    }
    let engineerStr = JSON.stringify(engineers);
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: this.taskDetail.order_task.company_id,
      order_task_id: this.taskDetail.order_task.id,
      work_user: engineerStr
    };
    taskCooperate(params).then(res => {
      this.showSuccessMsg('协同处理成功');
      this.close(true)
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private close(isReferesh:any) {
    this.$emit('close', false, isReferesh);
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "success",
    });
  }
}
